(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flosslo-shop-by-material"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function syncMaterials(root, id, shouldScrollTab = true) {
      if (!root || !id) return;

      const tabs = Array.from(root.querySelectorAll('[data-material-tab]'));
      const inputs = Array.from(root.querySelectorAll('[data-material-input]'));
      const panels = Array.from(root.querySelectorAll('[data-material-panel]'));

      inputs.forEach((input) => {
        input.checked = input.dataset.materialInput === id;
      });

      tabs.forEach((tab) => {
        const active = tab.dataset.materialTab === id;
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && shouldScrollTab) {
          tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        }
      });

      panels.forEach((panel) => {
        const active = panel.dataset.materialPanel === id;
        panel.classList.remove('is-active');
        panel.style.display = '';
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          const track = panel.querySelector('[data-material-track]');
          if (track) track.scrollTo({ left: 0, behavior: 'auto' });
        }
      });
    }

    function updateScrollProgress(scroller, progress) {
      if (!scroller || !progress || !window.matchMedia('(max-width: 749px)').matches) {
        if (progress) progress.hidden = true;
        return;
      }

      const thumb = progress.querySelector('[data-scroll-progress-thumb]');
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (!thumb || maxScroll <= 2) {
        progress.hidden = true;
        return;
      }

      const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
      const thumbWidth = Math.max(visibleRatio * 100, 18);
      const travel = 100 - thumbWidth;
      const offset = (scroller.scrollLeft / maxScroll) * travel;
      progress.hidden = false;
      thumb.style.width = `${thumbWidth}%`;
      thumb.style.marginLeft = `${offset}%`;
    }

    function activateFromTrigger(trigger) {
      const tab = trigger && trigger.closest ? trigger.closest('[data-material-tab]') : null;
      const root = tab ? tab.closest('.flosslo-materials') : null;
      if (!tab || !root) return;
      if (typeof root.activateMaterial === 'function') {
        root.activateMaterial(tab.dataset.materialTab);
      } else {
        syncMaterials(root, tab.dataset.materialTab);
      }
    }

    if (!document.documentElement.dataset.flossloMaterialsBound) {
      document.documentElement.dataset.flossloMaterialsBound = 'true';
      let pointerTarget = null;

      document.addEventListener('pointerdown', (event) => {
        const tab = event.target.closest('.flosslo-materials [data-material-tab]');
        if (!tab) return;
        pointerTarget = {
          id: event.pointerId,
          tab,
          x: event.clientX,
          y: event.clientY
        };
      }, true);

      document.addEventListener('pointerup', (event) => {
        const tab = event.target.closest('.flosslo-materials [data-material-tab]') || (pointerTarget ? pointerTarget.tab : null);
        if (!tab) return;

        const moved = pointerTarget
          ? Math.abs(event.clientX - pointerTarget.x) > 8 || Math.abs(event.clientY - pointerTarget.y) > 8
          : false;
        pointerTarget = null;

        const scroller = tab.closest('.flosslo-materials__tabs');
        if (moved || (scroller && scroller.dataset.dragged === 'true')) return;
        activateFromTrigger(tab);
      }, true);

      document.addEventListener('click', (event) => {
        const tab = event.target.closest('.flosslo-materials [data-material-tab]');
        if (!tab) return;
        const scroller = tab.closest('.flosslo-materials__tabs');
        if (scroller && scroller.dataset.dragged === 'true') return;
        activateFromTrigger(tab);
      }, true);

      document.addEventListener('keydown', (event) => {
        const tab = event.target.closest('.flosslo-materials [data-material-tab]');
        if (!tab || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        activateFromTrigger(tab);
      });
    }

    function initMaterials(root) {
      if (!root) return;

      if (root.dataset.flossloMaterialsReady === 'true') return;
      root.dataset.flossloMaterialsReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-material-tab]'));
      const inputs = Array.from(root.querySelectorAll('[data-material-input]'));
      const panels = Array.from(root.querySelectorAll('[data-material-panel]'));
      const tabScroller = root.querySelector('.flosslo-materials__tabs');
      const tabProgress = root.querySelector('[data-material-tabs-progress]');

      function refreshArrows(panel) {
        const track = panel.querySelector('[data-material-track]');
        const arrows = panel.querySelectorAll('[data-material-arrow]');
        if (!track) return;
        const needsArrows = track.scrollWidth > track.clientWidth + 2;
        arrows.forEach((arrow) => {
          arrow.hidden = !needsArrows;
        });
      }

      function sync(id, shouldScrollTab = true) {
        syncMaterials(root, id, shouldScrollTab);
        window.requestAnimationFrame(() => updateScrollProgress(tabScroller, tabProgress));
        panels.forEach((panel) => {
          if (panel.dataset.materialPanel === id) {
            window.requestAnimationFrame(() => refreshArrows(panel));
          }
        });
      }

      function activate(id) {
        const input = inputs.find((item) => item.dataset.materialInput === id);
        if (input) {
          input.checked = true;
        }
        sync(id);
      }

      function preloadMaterialVisuals() {
        if (root.dataset.materialVisualsPreloaded === 'true') return;
        root.dataset.materialVisualsPreloaded = 'true';

        const checkedInput = inputs.find((input) => input.checked);
        const activeId = checkedInput ? checkedInput.dataset.materialInput : '';
        const activeImages = [];
        const restImages = [];

        panels.forEach((panel) => {
          const image = panel.querySelector('.flosslo-materials__image');
          if (!image) return;
          if (panel.dataset.materialPanel === activeId) {
            activeImages.push(image);
          } else {
            restImages.push(image);
          }
        });

        const queue = [];
        const queuedSources = new Set();

        activeImages.concat(restImages).forEach((image) => {
          const key = image.currentSrc || image.getAttribute('src') || image.getAttribute('srcset') || '';
          if (!key || queuedSources.has(key)) return;
          queuedSources.add(key);
          queue.push(image);
        });

        if (!queue.length) return;

        const preloaders = [];
        let activeLoads = 0;
        let nextIndex = 0;
        root._flossloMaterialPreloaders = preloaders;

        function scheduleNext() {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(loadNext, { timeout: 700 });
          } else {
            window.setTimeout(loadNext, 90);
          }
        }

        function completeLoad() {
          activeLoads = Math.max(activeLoads - 1, 0);
          if (nextIndex < queue.length) scheduleNext();
        }

        function loadNext() {
          while (activeLoads < 2 && nextIndex < queue.length) {
            const sourceImage = queue[nextIndex];
            nextIndex += 1;
            activeLoads += 1;

            const preloader = new Image();
            const sizes = sourceImage.getAttribute('sizes');
            const srcset = sourceImage.getAttribute('srcset');
            const src = sourceImage.currentSrc || sourceImage.getAttribute('src') || sourceImage.src;
            let settled = false;

            preloader.decoding = 'async';
            if ('fetchPriority' in preloader) preloader.fetchPriority = 'low';
            if (sizes) preloader.sizes = sizes;
            if (srcset) preloader.srcset = srcset;
            preloader.src = src;
            preloaders.push(preloader);

            function settle() {
              if (settled) return;
              settled = true;
              completeLoad();
            }

            if (preloader.complete) {
              settle();
            } else {
              preloader.addEventListener('load', settle, { once: true });
              preloader.addEventListener('error', settle, { once: true });
              window.setTimeout(settle, 2500);
            }
          }
        }

        loadNext();
      }

      function scheduleMaterialVisualPreload() {
        const start = () => {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(preloadMaterialVisuals, { timeout: 1600 });
          } else {
            window.setTimeout(preloadMaterialVisuals, 700);
          }
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => window.setTimeout(start, 600), { once: true });
        } else {
          window.setTimeout(start, 600);
        }
      }

      if (tabScroller) {
        tabScroller.addEventListener('scroll', () => updateScrollProgress(tabScroller, tabProgress), { passive: true });

        let isDraggingTabs = false;
        let movedTabs = false;
        let startX = 0;
        let startY = 0;
        let startScrollLeft = 0;

        tabScroller.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          isDraggingTabs = true;
          movedTabs = false;
          startX = event.clientX;
          startY = event.clientY;
          startScrollLeft = tabScroller.scrollLeft;
          if (tabScroller.setPointerCapture) {
            tabScroller.setPointerCapture(event.pointerId);
          }
        });

        tabScroller.addEventListener('pointermove', (event) => {
          if (!isDraggingTabs) return;
          const deltaX = event.clientX - startX;
          const deltaY = event.clientY - startY;
          if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
            movedTabs = true;
            tabScroller.classList.add('is-dragging');
            tabScroller.scrollLeft = startScrollLeft - deltaX;
            event.preventDefault();
          }
        });

        function stopTabDrag(event) {
          if (!isDraggingTabs) return;
          isDraggingTabs = false;
          tabScroller.classList.remove('is-dragging');
          if (tabScroller.releasePointerCapture && event.pointerId) {
            tabScroller.releasePointerCapture(event.pointerId);
          }
          if (movedTabs) {
            tabScroller.dataset.dragged = 'true';
            window.setTimeout(() => {
              delete tabScroller.dataset.dragged;
            }, 120);
          }
        }

        tabScroller.addEventListener('pointerup', stopTabDrag);
        tabScroller.addEventListener('pointercancel', stopTabDrag);
        tabScroller.addEventListener('click', (event) => {
          if (tabScroller.dataset.dragged === 'true') {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true });
      }

      root.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-material-tab]');
        if (!tab || !root.contains(tab)) return;
        if (tabScroller && tabScroller.dataset.dragged === 'true') return;
        activate(tab.dataset.materialTab);
      }, { capture: true });

      root.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-material-tab]');
        if (!tab || !root.contains(tab)) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate(tab.dataset.materialTab);
      });

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked) {
            sync(input.dataset.materialInput);
          }
        });
      });

      root.querySelectorAll('[data-material-arrow]').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const panel = arrow.closest('[data-material-panel]');
          const track = panel ? panel.querySelector('[data-material-track]') : null;
          if (!track) return;
          const firstCard = track.querySelector('[data-material-card]');
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const step = firstCard ? (firstCard.getBoundingClientRect().width + gap) * 2 : track.clientWidth;
          track.scrollBy({ left: arrow.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });

      root.activateMaterial = activate;
      const checkedInput = inputs.find((input) => input.checked);
      if (checkedInput) {
        sync(checkedInput.dataset.materialInput, false);
      }
      scheduleMaterialVisualPreload();
      panels.forEach(refreshArrows);
      window.addEventListener('resize', () => {
        panels.forEach(refreshArrows);
        updateScrollProgress(tabScroller, tabProgress);
      });
      updateScrollProgress(tabScroller, tabProgress);
    }

    function initAllMaterials() {
      document.querySelectorAll('.flosslo-materials').forEach(initMaterials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllMaterials);
    } else {
      initAllMaterials();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('.flosslo-materials');
      if (root) initMaterials(root);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target.closest('[data-material-tab]');
      const panel = event.target.closest('[data-material-panel]');
      let root = event.target.closest('.flosslo-materials');
      let blockId = '';

      if (tab) {
        blockId = tab.dataset.materialTab;
      } else if (panel) {
        blockId = panel.dataset.materialPanel;
      } else if (event.detail) {
        blockId = event.detail.blockId || event.detail.block_id || '';
      }

      if (!root && blockId) {
        const matchingTab = Array.from(document.querySelectorAll('[data-material-tab]')).find((item) => item.dataset.materialTab === blockId);
        root = matchingTab ? matchingTab.closest('.flosslo-materials') : null;
      }

      if (root && root.activateMaterial && blockId) {
        root.activateMaterial(blockId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
